module.exports = __webpack_public_path__ + "static/media/clue010202.3a76fd05.jpg";